import styled from 'styled-components'


export const List = styled.ul`
    font-size: 22px;
    margin-top: 10%;
    color: white;
    list-style: none;
    text-align: center;
    @media only screen and (max-device-width: 800px) {
        margin-top: 25%;
        font-size: 14px;
    }
`

export const ListItem = styled.li`
    position: relative;
    display: inline-flex;
    text-align: center;
    padding: 2px 10px;
    align-items: center;

    img{
        height: 50px;
        width: 50px;
        margin-right: 10px;
        &:hover, &:focus{
            opacity: .5;
            cursor: pointer;
        }
        @media only screen and (max-device-width: 800px) {
            height: 20px;
            width: 20px;
        }
    }

`
export const Title = styled.h1`
    margin-top: 10%;
    color: white;
    text-align: center;

    @media only screen and (max-device-width: 800px) {
        margin-top: 25%;
        font-size: 20px;
    }
`
